import React, { useState } from "react";
import '../assets/css/ToggleSwitch.css';

const NotificationToggle = ({ label = "Toggle" }) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleChange = (e) => {
    const checked = e.target.checked;
    setIsChecked(checked);
    // alert(checked);
  };

  const handleReset = () => {
    setIsChecked(false);
    // alert(false);
  };

  return (
    <div className="d-flex justify-content-between align-items-center w-100 switchbtn ">
      <div>
        <button onClick={handleReset}></button>
        <span className="lablename">{label}</span>
      </div>


    <div>
      <input
        type="checkbox"
        className=""
        checked={isChecked}
        onChange={handleChange}
      />

      {isChecked && <span className="checkon"></span>}
    </div>
    </div>
  );
};

export default NotificationToggle;




